'use client';

import {Toaster} from '@udemy-v2/react-notice-components';

/**
 * Client component wrapper for the Toaster component.
 * Required because Toaster uses mobx-react-lite which needs client-side React hooks.
 */
export function ToasterProvider() {
    return <Toaster />;
}
